import { createSelector } from 'reselect';

import { epg2ProfileTvPackage } from '~/src/features/domru-tv/packages/helpers/epgPackageFormatter';
import { TState } from '~/src/store';
import { IPackageTheme, ITvPackage } from '~/src/store/reducers/tvPackages';

export interface IChannel {
    [key: string]: any,
}

export function selectPackagesInTariff(state: TState): Array<ITvPackage> {
    return state.tvPackages.connectedInTariff;
}

export function selectAllProfileTvPackages(state: TState): Array<ITvPackage> {
    return [...state.tvPackages.connectedInTariff, ...state.tvPackages.connectedOutTariff, ...state.tvPackages.canConnect];
}

export const selectFormattedTvPackages = createSelector(
    (state: TState) => state.tvPackages.allPackages,
    tvPackages => epg2ProfileTvPackage(tvPackages),
);

export const selectPackagesThemes = createSelector(
    [
        (state: TState) => state.auth.isAuth,
        selectAllProfileTvPackages,
        selectFormattedTvPackages,
    ],
    (isAuth, profileTvPackages, epgTvPackages) => {
        const tvPackages = isAuth ? profileTvPackages : epgTvPackages;

        const themesTitles: string[] = [];
        const noThemePackages: IPackageTheme = {
            id: 0,
            title: 'Прочие',
            packets: [],
        };

        const themePackages = tvPackages.reduce((acc: IPackageTheme[], tvPackage) => {
            if (tvPackage.themes?.length) {
                tvPackage.themes.forEach(pakcageTheme => {
                    if (!themesTitles.includes(pakcageTheme.title)) {
                        themesTitles.push(pakcageTheme.title);
                        const newTheme = {
                            ...pakcageTheme,
                            packets: [tvPackage],
                        };
                        acc.push(newTheme);
                    } else {
                        acc.forEach(_theme => {
                            if (pakcageTheme.title === _theme.title) {
                                _theme.packets.push(tvPackage);
                            }
                        });
                    }
                });
            } else {
                noThemePackages.packets.push(tvPackage);
            }

            return acc;
        }, []);

        return [...themePackages.sort((a, b) => a.id - b.id), noThemePackages];
    },
);

export function selectTrialPackage(state: TState): ITvPackage | null {
    return state.tvPackages.trialPackage;
}
